import React from 'react';
import PositionTable from './PositionTable';
import SettlementTable from './SettlementTable';

module.exports = () => {
  return (
    <section className="finery h100%">
      <PositionTable className="finery-position h50% rlv mb20"/>
      <SettlementTable className="finery-settlement h50% rlv mt20"/>
    </section>
  );
};
